import { Component, OnInit } from '@angular/core';
import {
  PageEvent,
} from '@app/components/paginator/paginator.component';
import { ActivatedRoute, Router } from '@angular/router';
import { InternalNotificationsService } from '../services/internal-notificacions.service';
import { BaseComponent } from '@app/components/base/base.component';
import { MenusServices } from '@app/services/menus.service';
import { AuthService } from '@app/common/auth.service';
import { QueryParamsNotifications } from '../models/notifications.model';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-internal-notifications',
  templateUrl: './internal-notifications.component.html',
  styleUrls: ['../internal-notifications.css'],
})
export class InternalNotificationsComponent
  extends BaseComponent
  implements OnInit
{
  isLoading: boolean = false;
  notifications: any[] = [];
  notificationsSelected: any[] = [];
  selectAllItems: boolean = false;
  selectedRow: any;
  list: any[] = [];
  enabled: boolean;
  userId: number;
  enabledNotificacions: any;
  messages!: string[];
  readonly seenOptions = [
    { label: 'Todas', value: null },
    { label: 'Leídas', value: true },
    { label: 'No leídas', value: false },
  ];
  titleInput = {
    placeholder: 'Buscar por asunto',
    value: '',
  };
  filterDraft = {
    from: null as Date | null,
    to: null as Date | null,
    seen: null as boolean | null,
  };
  selectResetKey = 0;

  pageSize = this.authService.getCurrentPaginators.pageSize;
  pageIndex =  this.authService.getCurrentPaginators.page;
  totalNotifications: number = 0;

  params: QueryParamsNotifications = {
    page: this.pageIndex,
    pageSize: this.pageSize,
    title: '',
    from: null,
    to: null,
    seen: null,
  };

  selectRow(id: number) {
    this.selectedRow = id;
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    route: ActivatedRoute,
    menuService: MenusServices,
    private notificationService: InternalNotificationsService,
    private notificationsService: NotificationService
  ) {
    super(route, menuService);
    this.messages = [];
  }

  ngOnInit(): void {
    this.userId = Number(this.authService.currentUserIds);
    this.list = [];
    this.loadEmailNotificationPreference();
    this.trackerService.track("UserLoadInternalNotifications", {
      userId: this.userId,
      params: this.params
    });
    this.sendDataToMenu();
    this.getNotifications();
  }

  private loadEmailNotificationPreference(): void {
    this.enabledNotificacions = this.authService.currentEnabledNotifications;
    this.notificationService
      .getEmailNotificationPreference(this.userId)
      .subscribe({
        next: (response) => {
          const enabled = Boolean(response?.data?.enabledNotification);
          this.enabledNotificacions = enabled;
          this.authService.setCurrentEnabledNotifications = enabled;
        },
        error: () => {
          this.enabledNotificacions =
            this.authService.currentEnabledNotifications ?? false;
        },
      });
  }

  getNotifications() {
    this.isLoading = true;
    this.notificationService
      .listNotificationsUser(this.params, this.userId)
      .subscribe({
        next: (response) => {
          this.notifications = response.data;
          this.totalNotifications = response.totalElements;
          this.pageIndex = response.page - 1;
          this.isLoading = false;
          this.trackerService.track("UserGetNotificationsSuccess", {
            userId: this.userId,
            params: this.params
          });
        },
        error: (error) => {
          this.isLoading = false;
          this.messages.push(
            'Hubo un error de conexión con nuestro servidor. Por favor, intente nuevamente o solicite soporte.'
          );
          this.notificationsService.showMessage(this.messages, 'error');
          setTimeout(() => {
            this.messages = [];
            this.notificationsService.clearMessages();
          }, 5000);
          this.trackerService.track("UserGetNotificationsError", {
            userId: this.userId,
            messages: error?.message ?? ""
          });
        },
      });
  }

  onTitleChange(title: string): void {
    this.titleInput.value = title;
  }

  onDateFromChange(date: Date): void {
    this.filterDraft.from = date ?? null;
  }

  onDateToChange(date: Date): void {
    this.filterDraft.to = date ?? null;
  }

  onSeenChange(seen: boolean | null): void {
    this.filterDraft.seen = seen;
  }

  searchWithFilters(): void {
    this.params = {
      ...this.params,
      ...this.filterDraft,
      page: 1,
      title: this.titleInput.value.trim(),
    };
    this.pageIndex = 0;
    this.authService.setCurrentPaginators = {
      page: 1,
      pageSize: this.params.pageSize,
      filter: '',
    };
    this.getNotifications();
  }

  clearFilters(): void {
    this.titleInput.value = '';
    this.filterDraft = {
      from: null,
      to: null,
      seen: null,
    };
    this.params = {
      ...this.params,
      page: 1,
      title: '',
      from: null,
      to: null,
      seen: null,
    };
    this.pageIndex = 0;
    this.selectResetKey += 1;
    this.getNotifications();
  }

  onCheckEmailNotificationChange(event: any) {
    this.trackerService.track('UserOnCheckEmailNotificationChange', {
      enabled: event.target.checked,
    });
    this.isLoading = true;
    const previousValue = this.enabledNotificacions;
    this.enabled = event.target.checked;
    const model = {
      enabled: this.enabled,
    };
    this.notificationService
      .markNotificationsByEmail(this.userId, model)
      .subscribe({
        next: () => {
          this.enabledNotificacions = this.enabled;
          this.authService.setCurrentEnabledNotifications = this.enabled;
          this.messages.push('Su configuración ha sido guardada correctamente.');
          this.notificationsService.showMessage(this.messages, 'success');
          setTimeout(() => {
            this.messages = [];
            this.notificationsService.clearMessages();
          }, 5000);
          this.isLoading = false;
        },
        error: () => {
          this.enabledNotificacions = previousValue;
          this.messages.push(
            'Ha ocurrido un error. Vuelva a intentarlo o solicite soporte.'
          );
          this.notificationsService.showMessage(this.messages, 'error');
          setTimeout(() => {
            this.messages = [];
            this.notificationsService.clearMessages();
          }, 5000);
          this.isLoading = false;
        },
      });
  }

  selectAllRows() {
    this.list = [];
    for (let item of this.notifications) {
      item.selected = !this.selectAllItems;
      if (item.selected) {
        const selectedItem = {
          notificationId: item.notificationId,
          seenByUser: item.seenByUser,
        };
        this.list.push(selectedItem);
      }
    }
  }

  onCheckboxChange(item: any) {
    if (item.selected) {
      const selectedItem = {
        notificationId: item.notificationId,
        seenByUser: item.seenByUser,
      };
      this.list.push(selectedItem);
    } else {
      const index = this.list.findIndex(
        (selectedItem) => selectedItem.id === item.notificationId
      );
      if (index !== -1) {
        this.list.splice(index, 1);
      }
    }
  }

  viewDetails(id: number) {
    const notification = this.notifications.find(
      (n) => n.notificationId === id
    );
    if (!notification.seenByUser) {
      const model = {
        list: [
          {
            notificationId: id,
            seenByUser: true,
          },
        ],
      };

      this.notificationService.markAsSeen(model).subscribe({
        next: (response) => {},
        error: (error) => {},
      });
      this.router.navigate([`notifications/details/${id}`]);
    } else {
      this.router.navigate([`notifications/details/${id}`]);
    }
  }

  markNotificationSeen() {
    this.list.forEach((notification) => {
      notification.seenByUser = true;
    });
    const requestBody = {
      list: this.list,
    };
    this.notificationService.markAsSeen(requestBody).subscribe({
      next: (response) => {
        location.reload();
      },
      error: (error) => {},
    });
  }

  markNotificationNotSeen() {
    this.list.forEach((notification) => {
      notification.seenByUser = false;
    });
    const requestBody = {
      list: this.list,
    };
    this.notificationService.markAsSeen(requestBody).subscribe({
      next: (response) => {
        location.reload();
      },
      error: (error) => {},
    });
  }

  handlePage(e: PageEvent) {
    this.authService.setCurrentPaginators = {
      page: e.pageIndex + 1,
      pageSize: e.pageSize,
      filter: '',
    };
    this.params.page = e.pageIndex + 1;
    this.params.pageSize = e.pageSize;
    this.getNotifications();
  }

  stripHtml(html: string): string {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
}
